import React, { useContext, useEffect, useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import classNames from 'classnames';
import AppContext from 'context/Context';
import Logo from 'components/common/Logo';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import PropTypes from 'prop-types';
import AnimateCC from 'react-adobe-animate';
import { useBreakpoints } from 'hooks/useBreakpoints';

const NavbarTop = props => {
  const breakpoints = useBreakpoints();

  const {
    config: {
      showBurgerMenu,
      navbarPosition,
      navbarCollapsed,
      isDark,
      isNavbarVerticalCollapsed
    },
    setConfig
  } = useContext(AppContext);

  const [showDropShadow, setShowDropShadow] = useState(false);

  const handleBurgerMenu = () => {
    navbarPosition === 'top' && setConfig('navbarCollapsed', !navbarCollapsed);
    (navbarPosition === 'vertical' || navbarPosition === 'combo') &&
      setConfig('showBurgerMenu', !showBurgerMenu);
  };

  const setDropShadow = () => {
    showDropShadow;
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  return (
    <Navbar
      style={{
        backgroundColor: isDark ? '#2E4450' : '#FDFDFD',
        paddingLeft: breakpoints.width < 1200 ? '24px' : '60px'
      }}
      className={classNames(
        'navbar-glass  fs--1 navbar-top sticky-kit' +
          (props.simple ? ' simpleNavbarTop' : '')
      )}
      expand={
        navbarPosition === 'top' || navbarPosition === 'combo'
          ? topNavbarBreakpoint
          : true
      }
    >
      <Navbar.Toggle
        className={classNames('toggle-icon-wrapper me-md-3 me-2', {
          'd-lg-none': navbarPosition === 'top',
          [`d-${navbarBreakPoint}-none`]:
            navbarPosition === 'vertical' || navbarPosition === 'combo'
        })}
        as="div"
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>
      {isDark && (
        <div style={{ width: 55, paddingTop: 8 }}>
          <img src="/images/tick.svg" />
          {/* <AnimateCC animationName="LabsLogoWhite" paused={false} /> */}
        </div>
      )}
      {!isDark && (
        <div style={{ width: 55, paddingTop: 8 }}>
          <img src="/images/tick.svg" />
        </div>
      )}
      {navbarPosition === 'top' || navbarPosition === 'combo' ? (
        <Navbar.Collapse
          in={navbarCollapsed}
          className="scrollbar pb-3 pb-lg-0"
        >
          <Nav navbar>
            <NavbarTopDropDownMenus />
          </Nav>
        </Navbar.Collapse>
      ) : (
        <Nav
          navbar
          className={`align-items-center d-none d-${topNavbarBreakpoint}-block`}
          as="ul"
        ></Nav>
      )}
      <TopNavRightSideNavItem simple={props.simple} />
    </Navbar>
  );
};

NavbarTop.propTypes = {
  simple: PropTypes.bool
};

NavbarTop.defaultProps = {
  simple: false
};

export default NavbarTop;
